module.exports = __webpack_public_path__ + "static/media/wedding@2x.d65156fd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/wedding@2x.png
 ** module id = 2250
 ** module chunks = 50
 **/